<div class="content" role="main">

  <div *ngIf="!IsUserAuthenticated()">
    <!-- <app-user-login></app-user-login> -->
    <router-outlet></router-outlet>
  </div>

  <div *ngIf="IsUserAuthenticated() && !PasswordIsTemporary()">
    <app-body></app-body>
  </div>

  <div *ngIf="IsUserAuthenticated() && PasswordIsTemporary()">
    <app-user-change-password></app-user-change-password>
  </div>

</div>
